export const spacingBase = 4;

export const spacingScale = {
  none: 0,
  xxxs: 0.125,
  xxs: 0.25,
  xs: 0.5,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
  '2xl': 6,
  '3xl': 12,
  '4xl': 24,
  '5xl': 48,
  gutter: 20,
  section: 32,
} as const;

export type SpacingToken = keyof typeof spacingScale;

export const spacing = {
  none: spacingScale.none * spacingBase,
  xxxs: spacingScale.xxxs * spacingBase,
  xxs: spacingScale.xxs * spacingBase,
  xs: spacingScale.xs * spacingBase,
  sm: spacingScale.sm * spacingBase,
  md: spacingScale.md * spacingBase,
  lg: spacingScale.lg * spacingBase,
  xl: spacingScale.xl * spacingBase,
  '2xl': spacingScale['2xl'] * spacingBase,
  '3xl': spacingScale['3xl'] * spacingBase,
  '4xl': spacingScale['4xl'] * spacingBase,
  '5xl': spacingScale['5xl'] * spacingBase,
  gutter: spacingScale.gutter * spacingBase,
  section: spacingScale.section * spacingBase,
} as const;

export const s = (token: SpacingToken): string => `${spacing[token]}px`;
